var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-menu-float" }, [
    _c(
      "div",
      { staticClass: "menu-inner" },
      _vm._l(_vm.menu, function (item, index) {
        return _c("ul", { class: _vm.setUlClass(index) }, [
          _c(
            "li",
            {
              staticClass: "head",
              on: {
                click: function ($event) {
                  return _vm.openMenu(index)
                },
              },
            },
            [
              _c("span", [_vm._v(_vm._s(index + 1))]),
              _vm._v(" " + _vm._s(item.name)),
            ]
          ),
          _vm._v(" "),
          _c("li", { staticClass: "menu-content" }, [
            _c(
              "ol",
              _vm._l(item.sub, function (sub, subIndex) {
                return _c("li", [
                  _c(
                    "div",
                    {
                      class: {
                        selected:
                          _vm.routeSection == index &&
                          _vm.routeLevel == subIndex,
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(index + 1) + "." + _vm._s(subIndex + 1)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: { href: _vm.createLink(index, subIndex) },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.onMenuLinkClick(index, subIndex)
                            },
                          },
                        },
                        [_vm._v(_vm._s(sub))]
                      ),
                    ]
                  ),
                ])
              }),
              0
            ),
          ]),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _vm.$store.state.editor.version
      ? _c(
          "div",
          { staticClass: "buttons" },
          [
            _vm.isSuperAdmin()
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-bottom": "40px",
                      "font-size": "8px",
                    },
                  },
                  [
                    !_vm.isAggregation()
                      ? _c("div", [
                          _c(
                            "a",
                            {
                              staticStyle: { color: "white" },
                              attrs: {
                                href:
                                  "/api/download/viewinputjson?id=" +
                                  _vm.$store.state.editor.version
                                    .forecastVersionId,
                                target: "_blank",
                              },
                            },
                            [_vm._v("Download input json")]
                          ),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.state.editor.version.processStatus == 1 ||
            _vm.$store.state.editor.version.processStatus == 4
              ? [
                  _vm.$store.state.editor.validator.hasWarning
                    ? _c("p", { staticClass: "warning" }, [
                        _c(
                          "span",
                          { on: { click: _vm.onModalValidatorClick } },
                          [_vm._v("Click for warnings")]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$store.state.editor.validator.hasError
                    ? _c("p", { staticClass: "valid" }, [
                        _c(
                          "span",
                          { on: { click: _vm.onModalValidatorClick } },
                          [_vm._v("Click for required data")]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n                    Last saved: " +
                        _vm._s(
                          this.$moment
                            .utc(_vm.$store.state.editor.version.updateDate)
                            .local()
                            .format("DD MMM YYYY HH:mm:ss")
                        ) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "left",
                    attrs: {
                      type: "button",
                      disabled: _vm.$store.state.editor.validator.hasError,
                      value: "Run",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onRunClick($event)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "right",
                      class: { loading: this.$store.state.isSavingStudy },
                      on: {
                        click: function ($event) {
                          return _vm.onSaveClick($event)
                        },
                      },
                    },
                    [_vm._v("Save")]
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.state.editor.version.processStatus == 2
              ? [
                  _c(
                    "button",
                    {
                      staticClass: "left",
                      on: {
                        click: function ($event) {
                          return _vm.onViewClick($event)
                        },
                      },
                    },
                    [_vm._v("View")]
                  ),
                  _vm._v(" "),
                  !_vm.$parent.showAnonymousMenu
                    ? _c(
                        "button",
                        {
                          staticClass: "right",
                          on: {
                            click: function ($event) {
                              return _vm.onCopyClick($event)
                            },
                          },
                        },
                        [_vm._v("Copy")]
                      )
                    : _vm._e(),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.state.editor.version.processStatus == 3
              ? [
                  _c("button", { staticClass: "left loading" }, [
                    _vm._v("Running..."),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "right",
                      on: {
                        click: function ($event) {
                          return _vm.onCopyClick($event)
                        },
                      },
                    },
                    [_vm._v("Copy")]
                  ),
                ]
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }